import { useState } from 'react';
import { MediaLibrary } from '../components/MediaLibrary';
import { trpc } from '../lib/trpc';

export function MediaLibraryTest() {
  const [selectedVenueId, setSelectedVenueId] = useState<string>('');

  // Get list of venues for testing
  const { data: venues, isPending: isLoadingVenues } = trpc.venue.list.useQuery({
    limit: 10,
  });

  if (isLoadingVenues) {
    return (
      <div className="px-4 py-8">
        <p className="text-gray-600">Loading venues...</p>
      </div>
    );
  }

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Media Library Test Page
        </h1>
        <p className="text-gray-600 mb-6">
          Test the Media Library components with real venue data.
        </p>

        {/* Venue Selector */}
        <div className="bg-gray-50 rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
          <label htmlFor="venue-select" className="block text-sm font-medium text-gray-700 mb-2">
            Select a Venue to Test
          </label>
          <select
            id="venue-select"
            value={selectedVenueId}
            onChange={(e) => setSelectedVenueId(e.target.value)}
            className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
          >
            <option value="">Choose a venue...</option>
            {venues?.items.map((venue) => (
              <option key={venue._id} value={venue._id}>
                {venue.name} - {venue.address.city}, {venue.address.state}
              </option>
            ))}
          </select>
        </div>

        {/* Instructions */}
        {!selectedVenueId && (
          <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
            <h3 className="text-sm font-medium text-primary-800 mb-2">
              How to Test the Media Library
            </h3>
            <ul className="text-sm text-primary-700 space-y-1">
              <li>• Select a venue from the dropdown above</li>
              <li>• Upload images using drag-and-drop or click to browse</li>
              <li>• Use filters to search by tags or publication status</li>
              <li>• Click on images to view details and manage them</li>
              <li>• Select multiple images for bulk actions</li>
              <li>• Test publishing, unpublishing, and setting hero images</li>
            </ul>
          </div>
        )}
      </div>

      {/* Media Library Component */}
      {selectedVenueId && (
        <MediaLibrary
          entityType="venue"
          entityId={selectedVenueId}
          canUpload={true}
          canSetHero={true}
          canManageGallery={true}
          showSharedMedia={true}
        />
      )}
    </div>
  );
}